import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { GridContext } from 'contexts/GridContext';
import { dropGrupoQualidade } from 'utils/drops';
import Container from 'components/Container';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';

const Manutenção = () => {
  const rotina = 'QualidadeIndicador';
  const defaultValues = {
    descricao: '',
    grupo: null,
    orientacao: '',
    inivalid: null,
    fimvalid: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops(['QualidadeIndicador']);
      },
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(state) ? 'Editar' : 'Cadastrar') + ' Indicador de Qualidade'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="grupo"
              control={control}
              label="Grupo"
              options={dropGrupoQualidade}
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              name="orientacao"
              control={control}
              label="Orientação"
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="inivalid"
              control={control}
              label="Início da Validade"
              type="date"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="fimvalid"
              control={control}
              label="Fim da Validade"
              type="date"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
